import * as SelectPrimitive from "@radix-ui/react-select";

import type {
  TSelectGroupProps,
} from "@/ui/components/form/Select/Select.config";

export const SelectGroup = (props: TSelectGroupProps) => (
  <SelectPrimitive.Group
    data-component="SelectGroup"
    {...props}
  />
);

SelectGroup.displayName = SelectPrimitive.Group.displayName;
